export default __webpack_public_path__ + "static/media/ldo_ADJ_BIAS_nEN_nCff.db2917cb.svg";